import React, { useState } from "react";
import GeoResolverMain from "./GeoResolverMain";
import GeoResolverDetail from "./GeoResolverDetail";
import GeoResolverRegistration from "./GeoResolverRegistration";

const GeoResolverSetup = () => {
  const [activeTab, setActiveTab] = useState("Main");

  return (
    <div className="p-4">
      <div className="flex gap-4 mb-6">
        <button
          onClick={() => setActiveTab("Main")}
          className={`px-6 py-2 rounded font-semibold text-white transition-all ${activeTab === "Main" ? "bg-[#133a69] shadow-lg" : "bg-gray-400 hover:bg-gray-500"
            }`}
        >
          GeoResolver Main
        </button>
        <button
          onClick={() => setActiveTab("Detail")}
          className={`px-6 py-2 rounded font-semibold text-white transition-all ${activeTab === "Detail" ? "bg-[#133a69] shadow-lg" : "bg-gray-400 hover:bg-gray-500"
            }`}
        >
          GeoResolver Detail
        </button>
        <button
          onClick={() => setActiveTab("Registration")}
          className={`px-6 py-2 rounded font-semibold text-white transition-all ${activeTab === "Registration" ? "bg-[#133a69] shadow-lg" : "bg-gray-400 hover:bg-gray-500"
            }`}
        >
          GeoResolver Registration
        </button>
      </div>

      <div className="mt-4">
        {activeTab === "Main" && <GeoResolverMain />}
        {activeTab === "Detail" && <GeoResolverDetail />}
        {activeTab === "Registration" && <GeoResolverRegistration />}
      </div>
    </div>
  );
};

export default GeoResolverSetup;
